import React from 'react';
import Drawer from '@mui/material/Drawer';
import { Close } from '@mui/icons-material';
import {
  Panel,
  Head,
  HeadTitle,
  CloseButton,
  Body,
  Intro,
  SectionsTitle,
  SectionItem,
  SectionName,
  SectionText,
  Footer,
  CloseAction,
} from './HelpDrawer.styled';

export interface HelpSectionVM {
  name: string;
  text: string;
}

export interface HelpDrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  intro: string;
  sectionsTitle: string;
  sections: HelpSectionVM[];
  closeLabel: string;
}

export default function HelpDrawer({
  open,
  onClose,
  title,
  intro,
  sectionsTitle,
  sections,
  closeLabel,
}: HelpDrawerProps) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { boxShadow: '-8px 0 30px rgba(16, 24, 40, 0.18)' } }}
    >
      <Panel>
        <Head>
          <HeadTitle>{title}</HeadTitle>
          <CloseButton type="button" onClick={onClose} aria-label={closeLabel}>
            <Close />
          </CloseButton>
        </Head>
        <Body>
          <SectionsTitle>{sectionsTitle}</SectionsTitle>
          {sections.map(section => (
            <SectionItem key={section.name}>
              <SectionName>{section.name}</SectionName>
              <SectionText>{section.text}</SectionText>
            </SectionItem>
          ))}
          <Intro>{intro}</Intro>
        </Body>
        <Footer>
          <CloseAction type="button" onClick={onClose}>
            {closeLabel}
          </CloseAction>
        </Footer>
      </Panel>
    </Drawer>
  );
}
